import { render, staticRenderFns } from "./UserPowerBiVisual.vue?vue&type=template&id=4442f23a&scoped=true"
import script from "./UserPowerBiVisual.vue?vue&type=script&lang=js"
export * from "./UserPowerBiVisual.vue?vue&type=script&lang=js"
import style0 from "./UserPowerBiVisual.vue?vue&type=style&index=0&id=4442f23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442f23a",
  null
  
)

export default component.exports